import { Permission, UserClaims, Permissions } from '@lmt/shared-types';
export type { UserClaims };
import { jwtDecode } from 'jwt-decode';

export const permissionsMappings: { [permission in Permission]: string } = {
  accessToAllSubtenants: 'AccessToAllSubtenants',
  createSubtenant: 'CreateSubtenant',
  userManagement: 'UserManagement',
  roleManagement: 'RoleManagement',
  dictionariesManagement: 'DictionariesManagement',
  editMeasurementMappings: 'EditMeasurementMappings',
  importMeasurements: 'ImportMeasurements',
  configureMeasurementUI: 'ConfigureMeasurementUI',
  developerMode: 'DeveloperMode',
  documentTemplateManagement: 'DocumentTemplateManagement',
  patientDeleteAndRestore: 'PatientDeleteAndRestore',
  dataBlockManagement: 'DataBlockManagement',
  calendarSettingsManagement: 'CalendarSettingsManagement',
  editExternalPatientNumber: 'EditExternalPatientNumber',
  tenantSettingsChange: 'TenantSettingsChange',
  manageResources: 'ManageResources',
  deleteDocuments: 'DeleteDocuments',
  createOrEditDocuments: 'CreateOrEditDocuments',
  manageSharedCalendarConfigurations: 'ManageSharedCalendarConfigurations',
  editPersonalDashboardUIConfiguration: 'EditPersonalDashboardUIConfiguration',
  editTenantDashboardUIConfiguration: 'EditTenantDashboardUIConfiguration',
  editPersonalPatientOverviewUIConfiguration:
    'EditPersonalPatientOverviewUIConfiguration',
  editTenantPatientOverviewUIConfiguration:
    'EditTenantPatientOverviewUIConfiguration',
  mergePatients: 'MergePatients',
  patientAnonymizeAndDeletePermanently: 'PatientAnonymizeAndDeletePermanently',
  statisticsDesigner: 'StatisticsDesigner',
  doctorManagement: 'DoctorManagement',
  hl7: 'HL7',
  hl7Transporter: 'Hl7Transporter',
  gdt: 'GDT',
  gdtTransporter: 'GdtTransporter',
  manageSharedPatientListConfigurations:
    'ManageSharedPatientListConfigurations',
  manualMeasurementImporting: 'ManualMeasurementImporting',
  manageAbsences: 'ManageAbsences',
  manageNotes: 'ManageNotes',
  deleteCases: 'DeleteCases',
  inputTemplateManagement: 'InputTemplateManagement',
  superuser: 'SuperUserMode',
  reImportAllMeasurements: 'ReImportAllMeasurements',
  reopenCase: 'ReopenCase',
  editDataBlockTypesAndFields: 'EditDataBlockTypesAndFields',
  hl7Management: 'Hl7Management',
  gdtManagement: 'GdtManagement',
  deleteVisits: 'DeleteVisits',
  resetPassword: 'ResetPassword',
  deleteDictionaries: 'DeleteDictionaries',
  auditLog: 'AuditLog',
  statisticsReport: 'StatisticsReport',
  passwordValidationSettings: 'PasswordValidationSettings',
  generateTestData: 'GenerateTestData',
  mockEgkCardReader: 'MockEgkCardReader',
  sendDocumentByEmail: 'SendDocumentByEmail',
};

export function decodeClaimsFromToken(token: string): UserClaims {
  const claims = jwtDecode(token) as any;
  claims.subtenants = claims.subtenants.split(',');
  const typedClaims = claims as UserClaims;
  const permissionsFromServer: string[] = claims.PERMISSION || [];
  typedClaims.permissions = convertPermissionsFromServer(permissionsFromServer);
  return typedClaims;
}

export function convertPermissionsFromServer(
  permissionsFromServer: string[],
): Permissions {
  const permissions: Partial<Permissions> = {};
  (Object.keys(permissionsMappings) as Permission[]).forEach((permission) => {
    permissions[permission] = permissionsFromServer.includes(
      permissionsMappings[permission],
    );
  });
  return permissions as Permissions;
}

export function permissionsAreEqual(
  permissions1: Permissions,
  permissions2: Permissions,
): boolean {
  return JSON.stringify(permissions1) === JSON.stringify(permissions2);
}
